import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  useTheme,
  useMediaQuery,
  Divider,
} from '@mui/material';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import SEOHead from '../components/SEOHead';

function AgenciasPromotores() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleContactClick = () => {
    window.location.href = 'mailto:hola@voybus.com?subject=Quiero unirme a la Red VOYBUS';
  };

  return (
    <>
      <SEOHead
        title="Agencias y Promotores - VoyBus"
        description="Únete a la Red VOYBUS. Programa de agencias y promotores para expandir tu negocio de viajes con nuestros paquetes y servicios."
        keywords={['agencia de viajes', 'promotores', 'red de agencias', 'franquicia viajes']}
        url="/agencias-promotores"
        type="website"
      />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-content, .print-content * {
              visibility: visible;
            }
            .print-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              background: white;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>
      <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa', py: 4 }} className="print-content">
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.4rem', sm: '1.75rem', md: '2.5rem' },
              mb: 2,
              color: 'text.primary',
            }}
          >
            🌟 Sé Parte de la Red 
          </Typography>
          <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
               Comercializá nuestros viajes y ganá con nosotros
             </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            ¿Tenés una agencia de viajes, sos un promotor independiente o generás contenido sobre turismo?
            Queremos que formes parte de nuestra comunidad de ventas y ganes dinero ofreciendo nuestros viajes y experiencias.
          </Typography>

          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            Ya sea que vendas todos los días o solo de vez en cuando, acá vas a encontrar una oportunidad real para crecer, sumar ingresos y ofrecer a tu audiencia o clientes viajes increíbles.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              🤝 ¿Quiénes pueden unirse?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Nuestro programa está pensado para:
            </Typography>
            <Box sx={{ pl: { xs: 2, md: 3 }, mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                ✅ Agencias de viajes
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                🧑‍💼 Promotores o vendedores independientes
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                📱 Creadores de contenido, bloggers o influencers del mundo del turismo
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                🏢 Empresas que quieren ofrecer beneficios o viajes a sus colaboradores
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, fontStyle: 'italic' }}>
              Si conectás personas con experiencias… vos podés ser parte.
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              💼 ¿Qué te ofrecemos?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Formar parte de nuestra exclusiva red de promotores significa:
            </Typography>
            <Box sx={{ pl: { xs: 2, md: 3 }, mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                ✨ Productos atractivos y fáciles de vender
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, pl: 2, fontStyle: 'italic' }}>
                Especializados en viajes en bus, escapadas, tours y experiencias accesibles.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                💰 Comisiones por cada venta confirmada
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, pl: 2, fontStyle: 'italic' }}>
                Ganás dinero vendiendo nuestros servicios. Simple.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                🎯 Soporte comercial y asesoría
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, pl: 2, fontStyle: 'italic' }}>
                Te acompañamos con materiales, capacitaciones y tips para vender mejor.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                📦 Productos para distintos perfiles de viajeros
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, pl: 2, fontStyle: 'italic' }}>
                Desde escapadas económicas hasta tours más completos.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                📁 Contenido y herramientas para ayudarte a vender
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, pl: 2, fontStyle: 'italic' }}>
                Artes, itinerarios, descripciones, copy sugerido para redes, etc.
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              🚀 ¿Cómo funciona?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              3 pasos simples:
            </Typography>
            <Box sx={{ pl: { xs: 2, md: 3 }, mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                1️⃣ Te sumás al programa completando el formulario
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                2️⃣ Te damos acceso a la info, tarifas y bases comerciales
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                3️⃣ Recomendás, promocionás o vendés nuestros viajes → Ganás comisión
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, fontStyle: 'italic' }}>
              Vos elegís cómo y cuánto querés vender.
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              🌍 ¿Por qué elegirnos?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Porque no solo comercializamos viajes — creamos experiencias que la gente realmente disfruta.
            </Typography>
            <Box sx={{ pl: { xs: 2, md: 3 }, mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                • Productos pensados para el mercado local
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                • Viajes probados y con excelentes valoraciones
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                • Opciones para público joven, familias, grupos y empresas
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                • Precios competitivos y accesibles
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                • Trato cercano, humano y transparente (cero burocracia innecesaria)
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, fontStyle: 'italic' }}>
              Acá no sos un número, sos parte de la red.
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              🎁 Beneficios para Empresas
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Si tenés una empresa y querés ofrecer beneficios a tus empleados, comunidad o clientes, podés acceder a:
            </Typography>
            <Box sx={{ pl: { xs: 2, md: 3 }, mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                🏷️ Tarifas preferenciales
              </Typography>
              <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                🎫 Acceso anticipado a promos
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                🎉 Packs para grupos, viajes corporativos y escapadas para equipos
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, fontStyle: 'italic' }}>
              Una manera diferente de motivar, premiar y fidelizar.
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{ 
                fontWeight: 600, 
                mb: 2, 
                color: 'primary.main',
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
              }}
            >
              🙌 ¿Te gustaría ser parte?
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Nos encantaría conocerte.
              Contanos quién sos y cómo te gustaría sumarte, y te enviamos toda la info.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }} className="no-print">
              <Button
                variant="contained"
                color="primary"
                startIcon={<EmojiPeopleIcon />}
                onClick={handleContactClick}
                size="large"
                sx={{
                  px: 6,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  boxShadow: 4,
                  '&:hover': {
                    boxShadow: 6,
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Quiero unirme!
              </Button>
            </Box>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mt: 4, p: 3, backgroundColor: '#fff', borderRadius: 2 }}>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8, textAlign: 'center' }}>
              También podés contactarnos por{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'primary.main' }}>
                email: hola@voybus.com
              </Box>
              {' '}o por{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'primary.main' }}>
                WhatsApp: 098 88 51 51
              </Box>
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default AgenciasPromotores;

